import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateWorkflowBasicInfo } from '../../../state';

export const WorkflowDescriptionField: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentWorkflow = useAppSelector((state) => state.workflow.currentWorkflow);

  if (!currentWorkflow) return null;

  return (
    <TextField
      label="Description"
      value={currentWorkflow.description}
      onChange={(e) => dispatch(updateWorkflowBasicInfo({ description: e.target.value }))}
      size="small"
      multiline
      rows={2}
      fullWidth
      placeholder="Describe what this workflow does..."
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          '& .MuiInputBase-input': {
            paddingTop: '8px',
          }
        }
      }}
    />
  );
};

export default WorkflowDescriptionField;
